import { METHODS, request } from '../axiosInstances';

export default {
  get: (params = {}) => request(METHODS.GET, `/channels/`, { params }),
  getCount: (params = {}) => request(METHODS.GET, `/channels/count/`, { params }),
};
